module.exports = __webpack_public_path__ + "img/2.9e4a692c.svg";